import { createSlice } from '@reduxjs/toolkit';
import EPage from '../../utils/EPage';

const initialState = {
    page: EPage.none,
 };

export const switchPageSlice = createSlice({
    name: 'switchPage',
    initialState,
    reducers: {
        setPage(state, action) {
            state.page = action.payload;
        },
    }
});

export default switchPageSlice;